<template>
    <div>
        <Breadtabsheader/>
        <div class="h-content" style="">
            <!-- tab切换 -->
            <div class=" ">
                <el-tabs v-model="activeName" type="border-card">
                    <el-tab-pane label="国内市场" name="first" :key="'first'" v-if="!lkFlag">
                        <battleNetUser v-if="activeName === 'first'" />
                    </el-tab-pane>
                    <el-tab-pane label="血液" name="second" :key="'second'" v-if="!lkFlag">
                        <targetAgainstUserBlood v-if="activeName === 'second'" />
                    </el-tab-pane>
                    <el-tab-pane label="朗康" name="third" :key="'third'" v-if="showLkTab">
                      <targetAgainstUserLangk v-if="activeName === 'third'" />
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>
    </div>
</template>
<script>
import battleNetUser from './battleNetUser.vue'
import targetAgainstUserBlood from './targetAgainstUserBlood.vue'
import TargetAgainstUserLangk from './targetAgainstUserLangk.vue'
export default {
    components: {
        //Breadcrumb,
        battleNetUser,
        targetAgainstUserBlood,
        targetAgainstUserLangk: TargetAgainstUserLangk,
    },
    data() {
        return {
            // 默认第一个Tab
            activeName: "first",
            showLkTab: false,
            lkFlag:false,
        };

    },
    created() {
        if(this.$route.query.type){
            this.activeName = this.$route.query.type;
        }
        this.showLkTab = this.$store.getters.hasRole('swyl_admin,swyl_quyujl,hh_shichangneiqin');
        if(this.$store.getters.hasRole('hh_shichangneiqin')){
          this.lkFlag = true;
          this.activeName = 'third';
        }
    },
    methods: {
        //tab切换
        handleClick(tab) {
        },

    }
}
</script>
<style scoped>
.h-content{
    background: #fff
}
</style>
